var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6973 12.65C16.3889 12.1123 10.1615 1.36531 9.62872 0.447961C9.27868 -0.154273 8.44463 -0.144348 8.09424 0.447961C7.70362 1.10833 1.4445 11.8963 1.00957 12.6775C0.690733 13.2496 1.04289 14 1.76848 14H15.9339C16.5927 14 17.0826 13.321 16.6973 12.65ZM8.86307 12.5818C8.37374 12.5818 7.97691 12.1851 7.97691 11.6956C7.97691 11.2061 8.37374 10.8095 8.86307 10.8095C9.35259 10.8095 9.74923 11.2061 9.74923 11.6956C9.74923 12.1851 9.35259 12.5818 8.86307 12.5818ZM9.39477 9.74608C9.39477 10.1005 9.21754 10.2778 8.86307 10.2778C8.50861 10.2778 8.33138 10.1005 8.33138 9.74608L7.79968 4.60635C7.79968 4.07466 8.15415 3.54296 8.86307 3.54296C9.572 3.54296 9.92647 4.07466 9.92647 4.60635L9.39477 9.74608Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.69c5f09adb67450179b7751de90bf4ff.svg";
export { ForwardRef as ReactComponent };